import Text16 from '@sdk/components/ui/typography/Text16';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  Circle,
  CustomRadioButtonWrapper,
  Input,
  Radio
} from '@kiosk/common/components/ui/RadioButton/radioButton.styles';

type Props = {
  checked: boolean;
  label: string;
  fieldName: string;
  value: string | number;
};

const RadioButton = ({ checked, label, fieldName, value }: Props) => {
  return (
    <CustomRadioButtonWrapper>
      <Input name={fieldName} type="radio" defaultChecked={checked} value={value} />
      <Circle isChecked={checked}>
        <Radio isChecked={checked} />
      </Circle>
      <Text16 themeColor={ThemeColorType.gray}>{label}</Text16>
    </CustomRadioButtonWrapper>
  );
};

export default RadioButton;
